import { useState } from "react";
import { Frame, Node, Detail } from "@/components/diagrams/kit";

const SLOTS = {
  asset: ["Plant 1 · Line 3", "Capper C-302", "Filler F-301"],
  metric: ["OEE", "micro-stop minutes", "availability loss"],
  timeframe: ["last three shifts", "Shift C (22:00–06:00)", "this week vs last week"],
  action: ["compare", "explain", "prioritize", "drill down", "handover"],
};
const ACTION_COPY = {
  compare: "Compare {metric} for {asset} over {timeframe} using the same metric definition.",
  explain: "Explain the change in {metric} for {asset} over {timeframe} using only approved evidence, and list what is unknown.",
  prioritize: "Rank the {metric} losses on {asset} for {timeframe} by minutes lost.",
  "drill down": "Drill down {metric} for {asset} over {timeframe} from line to machine to tag.",
  handover: "Draft a shift handover for {asset} covering {metric} over {timeframe} with unresolved issues, owners and evidence.",
};

export default function PromptBuilder() {
  const [p, setP] = useState({ asset: null, metric: null, timeframe: null, action: null });
  const filled = Object.values(p).filter(Boolean).length;
  const prompt = p.action ? ACTION_COPY[p.action].replace("{asset}", p.asset || "[which asset?]").replace("{metric}", p.metric || "[which metric?]").replace("{timeframe}", p.timeframe || "[which timeframe?]") : "Why is the line bad?";
  return (
    <Frame title="Asset + Metric + Timeframe + Action" hint="Build an executable request" testId="diagram-prompt-builder">
      <div className="grid gap-4 sm:grid-cols-4">
        {Object.entries(SLOTS).map(([k, opts]) => (
          <div key={k} className="space-y-2">
            <div className="font-heading text-xs font-bold uppercase tracking-widest">{k}</div>
            {opts.map((o) => (
              <Node key={o} testId={`prompt-${k}-${o.replace(/\W+/g, "-").toLowerCase()}`} tone={p[k] === o ? "primary" : "neutral"} active={p[k] === o} onClick={() => setP({ ...p, [k]: p[k] === o ? null : o })}>{o}</Node>
            ))}
          </div>
        ))}
      </div>
      <div className="mt-5 flex items-center gap-3">
        <div className="h-1.5 flex-1 bg-muted"><div className="h-full bg-brand-primary transition-[width]" style={{ width: `${filled * 25}%` }} /></div>
        <span data-testid="prompt-readiness" className={`font-mono text-xs ${filled === 4 ? "text-brand-accent" : "text-brand-action"}`}>{filled === 4 ? "Executable" : `${4 - filled} gap(s) — assistant must ask`}</span>
      </div>
      <Detail testId="prompt-output"><span key={prompt} className="font-mono text-xs sm:text-sm">“{prompt}”{filled === 4 && " State assumptions and data gaps."}</span></Detail>
    </Frame>
  );
}
